import { createAxiosInstance } from './axiosInstanse'
import { refreshAccessToken } from './authService'
import { store } from '@/redux/store'
import { logout } from '@/redux/features/userSlice'
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import {
  getCurrentAppPath,
  rememberRedirectAfterLogin,
} from '@/utils/redirect-after-login'

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  _retry?: boolean
}

const request = {
  public: createAxiosInstance(false),
  private: createAxiosInstance(true),
}

// Error handler function
const handleError = (error: AxiosError) => {
  if (error.response?.status === 401) {
    // The session died while the user was working: keep the page they were on
    // (with its filters/ordering) so login returns them there.
    rememberRedirectAfterLogin(getCurrentAppPath())
    store.dispatch(logout())
    localStorage.removeItem('user')
  }
  return Promise.reject(error)
}

// Response interceptor for private requests with token refresh
request.private.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    const originalRequest = error.config as CustomAxiosRequestConfig

    if (
      error.response?.status === 401 &&
      originalRequest &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true

      try {
        const newAccessToken = await refreshAccessToken()
        if (newAccessToken) {
          originalRequest.headers = {
            ...originalRequest.headers,
            Authorization: `Bearer ${newAccessToken}`,
          }
          return axios(originalRequest)
        }
      } catch (err) {
        return handleError(err as AxiosError)
      }
    }

    return handleError(error)
  }
)

export default request
